<div class="op-wp-embedded-graph work-packages-embedded-view--container loading-indicator--location" #graphContainer [style.height]="chartHeight">
  @if (hasDataToDisplay) {
    <p id="chart-desc" class="sr-only">
      {{ chartSummary }}
    </p>
    <canvas baseChart
      role="img"
      aria-labelledby="chart-desc"
      [datasets]="chartData"
      [labels]="chartLabels"
      [type]="mappedChartType"
      [options]="internalChartOptions"
      >
      {{chartDescription}}
    </canvas>
  }
  @if (!hasDataToDisplay && initialized) {
    <op-no-results [title]="text.noResults" />
  }
</div>
